// extracted by mini-css-extract-plugin
module.exports = {"container":"MobileLayout_container__th0DP","header":"MobileLayout_header__XkoxJ","logoContainer":"MobileLayout_logoContainer__1pvZA","logo":"MobileLayout_logo__p__xs"};